export default {
	game_id: "alchemy",
	gameName: "Alchemy",

	stageWidth: 1280,
	stageHeight: 720,

	scripts: [
		"framework/src/vendor/jquery.min.js",
		"framework/src/vendor/tween.js",
		"framework/src/vendor/ph.js",
		"framework/src/vendor/jquery.keyframes.min.js",
	],

	infoPages: {
		separated: true,
	},

	game: {
		webfonts: [
			{
				className: "pakenhamregular",
			},
			"UbuntuMono-Regular",
			"Audiowide-Regular",
		],
		audio: {
			tracks: [],
		},
		freespins: {
			autostart: false,
		},
	},
	system: {
		audio: {
			tracks: [
				{
    name: 'Jackpot_sound',
    classVol: 'volume.normalWin',
    loop: false,
},
{
    name: 'JokerBonus_alert',
    classVol: 'volume.normalWin',
    loop: false,
},

				
			],
		},
	},
};
